import comp from "./TaggedFolders";
export default comp;
